import datacentral from '@/utils/axios/datacentral'
import { ErrorResponse, ResponseArray, ResponseObject } from '@/types/shared'
import { DataGridPayload } from 'vnetwork-ui/dist/components/GokuDataGrid'
import { Job, JobAttribute, JobCategory } from '../types'
import qs from 'query-string'
export const getJobs = async (payload: DataGridPayload) => {
    const response = await datacentral.get<ResponseArray<Job>>(
        `/jobs?${qs.stringify(payload)}`
    )
    return response?.data
}

export const getJobByID = async (id: number) => {
    const response = await datacentral.get<ResponseObject<Job>>(`/jobs/${id}`)
    return response?.data
}

export const createJob = async (
    payload: JobAttribute
): Promise<ResponseObject<Job> | ErrorResponse> => {
    const response = await datacentral.post(`/jobs`, payload)
    return response?.data
}

export const updateJob = async (payload: {
    id: number
    job: JobAttribute
}): Promise<ResponseObject<Job> | ErrorResponse> => {
    const response = await datacentral.put(`/jobs/${payload.id}`, payload.job)
    return response.data
}

export const publicJob = async (
    id: number
): Promise<ResponseObject<Job> | ErrorResponse> => {
    const response = await datacentral.put(`/jobs/${id}/public`)
    return response.data
}

export const unPublicJob = async (
    id: number
): Promise<ResponseObject<Job> | ErrorResponse> => {
    const response = await datacentral.put(`/jobs/${id}/un-public`)
    return response.data
}

export const deleteJobByID = async (
    id: number
): Promise<ResponseObject<string> | ErrorResponse> => {
    const response = await datacentral.delete(`/jobs/${id}`)
    return response.data
}

export const getJobCategories = async () => {
    const response =
        await datacentral.get<ResponseArray<JobCategory>>(`/job-categories`)
    return response?.data
}
export const getAllJobPublic = async (): Promise<ResponseArray<Job>> => {
    const response = await datacentral.get('/jobs/public_all')
    return response.data
}
export const getAllJobPublicOptions = async () => {
    const response = await getAllJobPublic()
    if (!response?.results || response.results.length === 0) {
        return []
    }
    return response.results.map((item) => ({
        label: item?.title,
        value: item?.title,
    }))
}
